.body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-ds-8);
  font-size: var(--text-ds-label);
  line-height: var(--text-ds-label--line-height);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-ds-3);
}

.exhibit {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-ds-4);
  padding: var(--spacing-ds-4);
  border-width: var(--border-ds-width-hairline);
  border-radius: var(--radius-ds-lg);
}

.title {
  font-size: var(--text-ds-body);
  line-height: var(--text-ds-body--line-height);
  font-weight: var(--font-weight-ds-semibold);
}

.section-title {
  font-weight: var(--font-weight-ds-semibold);
  text-transform: uppercase;
}

.heading {
  font-weight: var(--font-weight-ds-semibold);
}

.fees {
  font-weight: var(--font-weight-ds-medium);
}

.paragraph {
  line-height: var(--line-height-ds-relaxed);
}

.clause-title {
  font-weight: var(--font-weight-ds-semibold);
}

.cell {
  padding: var(--spacing-ds-3);
  text-align: left;
  vertical-align: top;
}
